import React from "react"
import { Flex } from "@chakra-ui/react"
import type { LandingPage as LandingPageType } from "types/cms"
import { usePageComponents } from "lib/cms/usePageComponents"

import { ATBConfirmation } from "basket_and_checkout/shared/components/ATBConfirmation"
import { useMultiPromoTracking } from "packages/acquisition/hooks/mutlitPromo.hooks"
import { useLandingPageContext } from "./LandingPageProvider"
import { DuplicateRafRedemptionModal } from "packages/acquisition/components/ReferAFriend/DuplicateRafRedemptionModal"

type LandingPageProps = {
  blocks: LandingPageType["blocks"]
}

export const LandingPage: React.FC<LandingPageProps> = ({ blocks }) => {
  const components = usePageComponents(blocks)
  const { ATBConfirmation: ATBConfirmationState, setATBConfirmation } =
    useLandingPageContext()

  useMultiPromoTracking()

  return (
    <Flex
      maxWidth="90rem"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      mx="auto"
    >
      {ATBConfirmationState && (
        <ATBConfirmation
          confirmation={ATBConfirmationState}
          setConfirmation={setATBConfirmation}
          source="LandingPage"
        />
      )}
      <DuplicateRafRedemptionModal />
      {components}
    </Flex>
  )
}
